import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getVariantUrl } from "../../../common/helpers/helpers";
import ConditionalLink from "../../atoms/ConditionalLink/ConditonalLink";

function VarsomeVariantLink({ match, genome }) {
  const variantName = match.replace(/##/g, "");
  const variant = variantName.replace("⇒", "-");
  const url = getVariantUrl(genome, variant, null, true);
  return <ConditionalLink href={url} text={variantName} />;
}

VarsomeVariantLink.propTypes = {
  genome: PropTypes.string,
  match: PropTypes.string,
};

VarsomeVariantLink.defaultProps = {
  genome: "",
  match: "",
};

const mapStateToProps = (state) => {
  return {
    varsomeHost: state.varsomeHost,
    genome: state.genome?.name,
    variantQueryMode: state.variantQueryMode,
  };
};

export default connect(mapStateToProps)(VarsomeVariantLink);
